// src/chapterApi.js
// Shared helpers for loading chapters from the API (app.js) and building page image URLs.

const apiBase = process.env.NODE_ENV === 'production'
  ? ''
  : 'http://localhost:3004';

// Page images follow this pattern: x = chapter number, y = page number
const pageUrlTemplate = 'https://r4.sinlessproject.com/media/DissentiaOG/sodogchxpgy.png';

// Returns chapters newest first. Pass a limit to only get the newest N.
export async function fetchChapters(limit) {
  const query = limit ? `?limit=${limit}` : '';
  const response = await fetch(`${apiBase}/api/chapters${query}`);
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
}

export async function fetchChapter(chapterNumber) {
  const response = await fetch(`${apiBase}/api/chapters/${chapterNumber}`);
  if (!response.ok) {
    throw new Error(response.status === 404 ? 'Chapter not found' : `HTTP error! status: ${response.status}`);
  }
  return response.json();
}

export function chapterPageUrl(chapterNumber, pageNumber) {
  return pageUrlTemplate
    .replace('chx', `ch${chapterNumber}`)
    .replace('pgy', `pg${pageNumber}`);
}

// Every page URL from 0 to lastPage (inclusive), in reading order
export function chapterPageUrls(chapter) {
  const urls = [];
  for (let page = 0; page <= chapter.lastPage; page++) {
    urls.push(chapterPageUrl(chapter.ChapterNumber, page));
  }
  return urls;
}

export function formatChapterDate(date) {
  if (!date) return '';
  return new Date(date).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
}
